// COCHE §10.1.10 — Simplified Chinese (default). Add new keys here first;
// the LocaleSwitcher writes "imles-locale" to localStorage and that drives
// vue-i18n at runtime. Server-side schema labels are localised separately
// via the X-Imles-Locale header → Jackson modifier swap.
export default {
	common: {
		save: "保存",
		cancel: "取消",
		delete: "删除",
		edit: "编辑",
		search: "搜索",
		export: "导出",
		import: "导入",
		confirm: "确定",
		yes: "是",
		no: "否",
		add: "新增",
		back: "返回",
		close: "关闭",
		operation: "操作",
		loading: "加载中…",
		empty: "暂无数据",
		opSuccess: "操作成功",
		opFailed: "操作失败",
		submit: "提交",
		reset: "重置",
		reload: "刷新",
		view: "查看",
		more: "更多",
		all: "全部",
		tip: "提示",
		confirmDelete: "确认是否删除?",
		pleaseSelect: "请选择",
		loadFailed: "加载失败",
		downloadSuccess: "下载成功",
		warning: "警告",
		operationSuccess: "操作成功",
		pleaseInput: "请输入",
		deleteSuccess: "删除成功",
		editSuccess: "编辑成功",
		addSuccess: "新增成功",
		viewSource: "溯源",
		confirmDeleteRecord: "确定删除当前记录？",
		recordSeqHeader: "序号",
		detail: "详情",
		requiredFieldHint: "缺少必填项，再次点击提交定位到输入框",
	},
	auth: {
		sessionExpired: "登录已过期，请重新登录。",
		permissionDenied: "您没有执行此操作的权限。",
		networkError: "无法连接服务器，请检查网络。",
		serverUnavailable: "服务暂时不可用，请稍后重试。",
	},
	login: {
		title: "登录",
		username: "用户名",
		password: "密码",
		submit: "登录",
		captcha: "验证码",
		rememberMe: "记住我",
		welcome: "欢迎登录",
		signIn: "登录",
		platformTitle: "科研数据库平台",
		platformTagline: "高效采集、灵活易用的临床科研数据解决方案",
		sxswTitle: "陕西省神经外科医疗质量控制中心数据填报系统",
		bgAlt: "背景图",
		tabPassword: "密码登录",
		tabSms: "验证码登录",
		tabWechat: "微信扫码登录",
		usernamePh: "请输入账号",
		passwordPh: "请输入密码",
		mobilePh: "请输入手机号",
		smsCodePh: "请输入短信验证码",
		captchaPh: "图形验证码",
		invalidMobile: "请输入11位有效手机号",
		getCode: "获取验证码",
		resendCode: "{sec}秒后重新获取",
		smsSent: "获取验证码成功",
		copyright: "© 2026 北京医合易生科技有限公司. 京ICP备 19052789-1",
		icpFiling: "京公网安备11011302007191",
		platformTitleMycoach: "临床数据平台",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. 保留所有权利。符合 HIPAA 与 PIPEDA 标准。",
	},
	nav: {
		dashboard: "工作台",
		patients: "患者",
		projects: "项目",
		schema: "模型",
		governance: "治理",
		settings: "设置",
		logout: "退出登录",
	},
	locale: {
		switcher: "语言",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "模型多语言翻译",
			scanProject: "扫描项目缺失",
			draftWithLlm: "AI 起草",
			applySelected: "保存所选",
			columnSource: "原文",
			columnSuggestion: "AI 建议",
			columnEdited: "您的修改",
			noMissing: "该项目所有字段均已翻译。",
		},
	},
	imaging: {
		title: "影像查看器",
		subtitle: "COCHE Tier-B — B2 查看器 · B4 标注 (cvd_hk)",
		studies: "检查",
		series: "序列",
		viewer: "查看器",
		reload: "重新加载",
		loading: "加载中…",
		prev: "上一张",
		next: "下一张",
		workspace: "工作台",
		metadata: "元数据",
		task: "任务",
		noImaging: "该患者暂无影像",
		selectSeries: "请选择序列",
		layersShort: "图层",
		frame: "帧",
		slice: "层",
		phase: "时相",
		axial: "横断",
		coronal: "冠状",
		sagittal: "矢状",
		play: "播放",
		pause: "暂停",
		wlAuto: "自动",
		wlCustom: "自定义",
		zoom: "缩放",
		reset: "重置",
		aiSegment: "AI 分割此体数据",
		segStarted: "分割任务已在 {backend} 启动",
		saving: "保存中…",
		frameUnavailable: "帧不可用（像素未缓存）",
		layers: "图层",
		newLayer: "新建图层",
		noLayers: "尚无标注图层",
		opacity: "透明度",
		delete: "删除",
		deleteLayerConfirm: "删除图层 #{id}？此操作不可撤销。",
		tools: "绘制工具",
		toolNone: "浏览",
		toolBrush: "画笔",
		toolEraser: "橡皮",
		toolPolygon: "多边形",
		toolGrow: "区域生长",
		radius: "半径",
		tolerance: "容差",
		toolHint: "画笔/橡皮：拖动。多边形：点击顶点，双击闭合。区域生长：点击种子点。每一笔都保存到所选标签。",
		readOnlyLayer: "该图层只读（仅可编辑自己的草稿图层）。",
		submitReview: "提交审阅",
		submitConfirm: "提交您的图层？提交后变为只读，所有读片者提交后自动计算一致性。",
		submitted: "已提交",
		phiRemoved: "入库时已去除的身份信息",
		chooseLabels: "选择标签",
		labelName: "标签名称",
		addLabel: "添加标签",
		cancel: "取消",
		create: "创建",
	},
	imagingWs: {
		title: "影像工作台",
		subtitle: "COCHE Tier-B — 检查 · 上传 · AI 分割任务 · 标注任务",
		noProject: "未选择项目 — 请从项目内打开，或在 URL 中加入 ?projectId=。",
		reload: "刷新",
		upload: "上传",
		purge: "清空项目影像数据",
		purgeConfirm: "删除本项目影像模块的全部检查、序列、标注和任务？此操作不可恢复。",
		purged: "已清除 {n} 个序列",
		tabStudies: "检查",
		tabJobs: "任务队列",
		tabTasks: "标注任务",
		patient: "患者",
		date: "日期",
		modality: "模态",
		description: "描述",
		seriesCount: "序列数",
		instances: "图像数",
		series: "序列",
		frames: "帧数",
		kind: "类型",
		annotations: "图层",
		actions: "操作",
		openViewer: "打开查看器",
		aiSegment: "AI 分割",
		delete: "删除",
		deleted: "已删除",
		deleteConfirm: "删除“{name}”？此操作不可撤销。",
		uploadTitle: "上传影像（DICOM / NIfTI / 图片）",
		uploadDrop: "拖拽文件到此处，或点击选择",
		uploadHint: "支持 DICOM（.dcm、文件夹）、NIfTI（.nii / .nii.gz）、PNG / JPEG。入库时自动去除患者身份信息。",
		chooseFolder: "选择文件夹…",
		patientNoOpt: "患者编号（可选）",
		files: "个文件",
		clear: "清空",
		startUpload: "开始上传",
		close: "关闭",
		job: "任务",
		file: "文件",
		bytes: "大小",
		status: "状态",
		reason: "原因",
		backend: "后端",
		progress: "进度",
		createdBy: "创建人",
		started: "开始时间",
		duration: "耗时",
		error: "错误 / 结果",
		jobStarted: "任务 #{id} 已在 {backend} 启动",
		segmentTitle: "AI 分割（TotalSegmentator）",
		segmentTask: "模型",
		start: "开始",
		cancel: "取消",
		newTask: "新建标注任务",
		taskTitle: "标题",
		readers: "读片者",
		adjudicator: "仲裁者",
		threshold: "Dice 阈值",
		labels: "标签",
		assigneesHint: "逗号分隔的用户名，如 coche_researcher, coche_admin",
		create: "创建",
		created: "任务已创建 — 每位读片者一个草稿图层",
		open: "打开",
		adjudicate: "仲裁",
		adjudicationTitle: "标注仲裁",
		gold: "金标准",
		needTwoReaders: "该任务需要两个读片者图层才能仲裁。",
		readerA: "读片者 A",
		readerB: "读片者 B",
		diff: "差异",
		agree: "一致",
		only: "独有",
		jumpAnnotated: "跳到已标注帧",
		perLabelDice: "各标签一致性",
		decision: "裁定",
		noteOpt: "备注（可选）",
		acceptA: "采纳 A 为金标准",
		acceptB: "采纳 B 为金标准",
		editA: "编辑 A → 金标准",
		editB: "编辑 B → 金标准",
		notDisputed: "任务状态为 {status} — 仅在争议状态下可裁定。",
		notAdjudicator: "仅仲裁者（{user}）可裁定该任务。",
		adjudicated: "已仲裁",
		goldLayer: "金标准图层",
		openInViewer: "在查看器中打开",
	},
	ml: {
		title: "联邦学习与模型注册",
		subtitle: "Flower FedAvg 跨站点训练——只有模型权重跨网传输，患者数据不出站点",
		reload: "重新加载",
		startRun: "启动联邦训练",
		rounds: "轮",
		minClients: "最少站点数",
		liveRun: "训练进行中",
		runs: "联邦训练任务",
		noRuns: "暂无联邦训练任务",
		status: "状态",
		roundsDone: "轮次",
		sites: "站点",
		waitingClients: "等待站点接入…",
		bytes: "发送字节",
		auc: "AUC",
		loss: "损失",
		started: "开始时间",
		runDetail: "任务详情",
		live: "实时",
		rowsTransferred: "传输的数据行",
		site: "站点",
		city: "城市",
		jurisdiction: "司法辖区",
		nSamples: "样本数",
		joinCommand: "新站点接入命令",
		copy: "复制",
		copied: "已复制",
		chartTitle: "各站点每轮损失（实线）与全局模型 AUC（虚线）",
		round: "轮次",
		models: "模型注册表",
		noModels: "暂无已注册模型",
		name: "名称",
		version: "版本",
		algorithm: "算法",
		artifactSha: "制品 SHA-256",
		job: "任务",
		stage: "阶段",
		actions: "操作",
		toStaging: "预发布",
		toProduction: "发布到生产",
	},
	timeseries: {
		title: "生理信号",
		streams: "信号流",
		viewer: "查看器",
		reload: "重新加载",
		live: "实时",
		ingestRate: "写入速率",
	},
	interop: {
		title: "FHIR / OMOP 互操作",
		framing: "FHIR R4 导出层 / OMOP CDM v5.4 导出 — HAPI FHIR 服务器与 OHDSI ETL 为正式部署形态。",
		coverage: "映射覆盖率",
		fields: "个字段",
		mapped: "已映射",
		review: "待复核",
		unmapped: "未映射",
		perModel: "按模型",
		model: "模型",
		conceptMap: "概念映射表",
		field: "字段",
		target: "目标",
		resource: "资源 / 表",
		element: "元素 / 列",
		vocabulary: "术语集",
		code: "编码",
		conceptId: "OMOP concept_id",
		display: "显示名",
		unit: "单位",
		status: "状态",
		note: "备注",
		search: "搜索字段 / 编码 / 显示名",
		save: "保存",
		cancel: "取消",
		edit: "编辑",
		saved: "映射已保存",
		reseed: "重置为预设映射",
		reseedConfirm: "重新应用内置预设映射？手动修改将被覆盖。",
		lookup: "值级查找表",
		domain: "域",
		sourceValue: "来源值",
		fhir: "FHIR R4 Bundle",
		patient: "患者",
		pickPatient: "选择患者",
		viewBundle: "查看 FHIR Bundle",
		openRaw: "打开原始 $everything",
		validate: "验证整个项目",
		validating: "正在验证所有患者…",
		resources: "资源",
		valid: "有效",
		invalid: "无效",
		bundleValid: "Bundle 通过 fhir.resources R4B 验证",
		bundleInvalid: "Bundle 验证失败",
		omop: "OMOP CDM v5.4",
		download: "下载 OMOP CDM (zip)",
		preview: "预览数据表",
		rows: "行",
		table: "数据表",
		reload: "重新加载",
		loading: "加载中…",
		noProject: "请先选择项目",
		collapseAll: "全部折叠",
		expandAll: "全部展开",
	},
	encryption: {
		title: "加密状态",
		enabled: "已启用",
		disabled: "未启用",
		mysql: "MySQL",
		reload: "重新加载",
		encryptAll: "加密全部",
		decryptAll: "解密全部",
	},
	header: {
		maskedHospital: "****医院",
		systemAdminConsole: "系统管理控制台",
		switchTenant: "切换租户",
		configForm: "配置表单",
		switchProject: "切换项目",
		setPassword: "设置密码",
		changePassword: "修改密码",
		avatarSettings: "头像设置",
		settings: "设置",
		logout: "退出登录",
		oldPassword: "原密码",
		newPassword: "新密码",
		confirmPassword: "确认密码",
		enterOldPassword: "请输入原密码",
		enterNewPassword: "请输入新密码",
		enterConfirmPassword: "请再次输入新密码",
		passwordMismatch: "两次密码不一致",
		tenantCodePrompt: "输入租户编码(必须是正确的租户编码)",
		passwordSetSuccess: "密码设置成功, 请重新登录",
		passwordChangeSuccess: "密码修改成功, 请重新登录",
		compactMode: "紧凑模式",
		compactModeDesc: "表单字段横向排列，行距更紧凑",
		darkMode: "深色模式",
		darkModeDesc: "仅本机生效，刷新后保留",
		dataMasking: "数据脱敏",
		dataMaskingDesc: "在列表/表单中隐藏敏感字段",
		fontTheme: "字体主题",
		fontThemeDesc: "选择更现代的中英文字体组合，仅本机生效，立即应用",
		fontThemeModern: "现代",
		fontThemeEditorial: "严谨",
		fontThemeFriendly: "清新",
		betaSuffix: "（BETA）",
		languageDesc: "界面语言，切换后页面会自动刷新",
		changePasswordDesc: "更新登录密码，修改后需重新登录",
		avatarSettingsDesc: "上传或更换头像图片",
		modify: "修改",
		displayName: "显示名称",
		displayNameDesc: "应用中显示的名称；登录用户名不可更改",
		editDisplayName: "修改显示名称",
		displayNamePlaceholder: "请输入显示名称",
		displayNameRequired: "请输入显示名称",
		displayNameLength: "显示名称长度需为 1–120 个字符",
		displayNameUpdated: "显示名称已更新",
		sectionAccount: "账户",
		sectionAppearance: "外观",
		sectionPrivacy: "隐私",
	},
	followup: {
		title: "随访列表",
		statTotalCase: "病例总量",
		statMonthlyDue: "本月应到期访视",
		statMonthlyDone: "本月已完成访视",
		statMonthlyOpen: "本月未完成访视",
		searchDate: "随访日期：",
		searchStatus: "随访状态：",
		searchPatient: "患者姓名/编号：",
		startDate: "开始时间",
		endDate: "结束时间",
		select: "请选择",
		input: "请输入",
		searchBtn: "查 询",
		resetBtn: "重 置",
		colIndex: "序号",
		colVisitPlan: "访视计划预览",
		colPatientName: "患者姓名",
		colPatientNo: "患者编号",
		colVisitDate: "随访日期",
		colVisitName: "访视名称",
		colStatus: "随访状态",
		colCenter: "所属中心",
		colOperation: "操作",
		actEdit: "编辑",
		actView: "查看",
		actCancel: "取消随访",
		statusPending: "未随访",
		statusOverdue: "已超窗",
		statusDone: "已随访",
		fieldKeyword: "请输入关键字",
		detailTitle: "随访详情",
	},
	multicenter: {
		overviewTitle: "多中心概览",
		patientTitle: "多中心患者列表",
		followupTitle: "多中心随访管理",
		colCenter: "中心",
		colTenant: "租户",
		colPatientCount: "病例数",
		colFollowupCount: "随访数",
		colCompleteness: "完整度",
		switchProject: "切换项目",
		statCenters: "中心数量",
		statPatients: "患者总数量",
		statFollowups: "随访总次数",
		statOverdue: "过期未随访",
		newPatientTrend: "患者新增趋势",
		today: "今日",
		thisWeek: "本周",
		thisMonth: "本月",
		thisYear: "全年",
		startDate: "开始日期",
		endDate: "结束日期",
		dateSep: "至",
		centerPatientCount: "中心患者数量",
		colRank: "排名",
		colCenterName: "中心名称",
		colUserCount: "用户数",
		colPatientCountAlt: "患者数量",
		patientGender: "患者性别",
		mcInfo: "多中心信息",
		caseCount: "病例数",
		departmentCount: "科室",
		mapCenters: "多中心分布图",
		mapPatients: "患者区域分布图",
		caseFilter: "病例数量筛选",
		all: "ALL",
		hospitalName: "医院名称：",
		departmentName: "科室名称：",
		projectName: "项目名称：",
		patientCountLabel: "病例数量：",
		emptyData: "暂无数据",
	},
	manage: {
		auditLog: "审计日志",
		piiRule: "PII规则配置",
		governanceInbox: "审批收件箱",
		myRequests: "我的申请",
		scopeTree: "组织架构",
		lifecycle: "生命周期",
		metadataVersioning: "模型版本",
		ingestionHardening: "导入加固",
		ehealth: "eHealth 上传",
		subCenter: "分中心",
		schema: "架构生成",
		agentConfig: "Agent配置",
		random: "随机化",
		consent: "知情同意书",
	},
	databaseConfig: {
		patientBasicInfo: "患者基本信息配置",
		databaseSection: "数据库配置",
		followupSection: "随访表配置",
		colNo: "序号",
		colFormCode: "表单编码",
		colFormName: "表单名称",
		colModelCount: "模型数",
		colOp: "操作",
		colFollowupCode: "随访表单编号",
		colFollowupName: "随访表单名称",
		colFollowupPlan: "关联随访计划",
		colFollowupPlanName: "关联随访计划名称",
		btnAdd: "新增",
		btnBatchAdd: "批量新增",
		btnDelete: "删除",
		btnEdit: "编辑",
		btnConfig: "配置",
		btnConfigFromTemplate: "从模板配置",
		btnConfigFromForm: "从项目表单配置",
		dlgEditTitle: "编辑",
		dlgAddTitle: "新增",
		dlgEditFollowupTitle: "编辑随访表",
		dlgAddFollowupTitle: "新增随访表",
		dlgFormName: "表单名称",
		dlgFollowupName: "随访表单名称",
		dlgPh: "请输入",
		dlgCancel: "取消",
		dlgConfirm: "确定",
	},
	memberPermissions: {
		title: "人员权限",
		colNo: "序号",
		colTenant: "租户",
		colUsername: "用户名",
		colNickname: "昵称",
		colFuncPermission: "功能权限",
		colDataPermission: "数据权限",
		colActions: "操作",
		btnConfigure: "配置",
		btnEdit: "修改",
		noRolesAssigned: "（未分配角色）",
		scopeCount: "范围：{f} 个表单 · {m} 个模型",
		actEditRoles: "编辑功能权限",
		actEditData: "编辑数据权限",
		actRemove: "移除医生",
		confirmRemove: "确认移除当前医生?",
		dlgAddTitle: "多中心人员管理",
		addHint: "通过精确的用户名、工号或手机号搜索成员；添加后再在右侧表格中配置功能权限与数据权限。",
		searchPh: "请输入精确的 用户名/工号/手机号…",
		searchNoMatch: "未找到匹配的用户 — 请检查拼写或使用准确账号",
		lblAccount: "账号",
		btnAddAnother: "添加",
		dlgFuncTitle: "功能权限配置",
		projectRolesLabel: "项目范围内的角色（可在此编辑）",
		globalRolesLabel: "全局生效的角色（请在「用户管理」中编辑）",
		globalRolesHint: "这些角色是在用户层级分配的，对所有项目都生效。请在用户管理页中维护，本处仅作只读展示。",
		projectRolesEmptyButGlobal: "该用户尚未分配项目级角色，其在本项目的权限完全来自上方的全局角色。如需为本项目单独授权，请在此选择。",
		projectRolesEmptyNoGlobal: "该用户尚未分配任何角色，请在此选择以授予项目级权限。",
		dlgDataTitle: "数据权限配置",
		dataBypassModelAdmin: "提示：该用户拥有 Model Administrator 角色，会完全绕过数据权限过滤。下方的选择会被保存，但在浏览时不会生效——这些设置仅对没有 Model Administrator 角色的用户起作用。",
		dataBypassProjectCreator: "提示：该用户是本项目的创建人，会完全绕过数据权限过滤。下方的选择会被保存，但在浏览时不会生效——项目创建人始终可以看到全部表单与模型。",
		sodWarnTitle: "职责分离警告 ({n} 项冲突) — 仍可保存",
		sodErrorTitle: "职责分离冲突 ({n} 项) — 该项目已开启强制校验，无法保存",
		sodEnforceBlocked: "职责分离冲突 — 请移除冲突角色后再保存",
		sodWarnSaved: "已保存，但存在 {n} 项职责分离警告",
	},
	sod: {
		tagPending: "（待添加）",
		tagAssigned: "（已分配）",
		violationLine: "{a} 与 {b} 冲突 ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "按租户筛选",
		visibilityTitle: "我的可见范围",
		visibilityPrompt: "点击『刷新』查询当前会话的可见项目集",
		fUserId: "用户 ID",
		fBypass: "绕过过滤",
		bypassYes: "是 (bypass)",
		bypassNo: "否 (enforced)",
		fReason: "原因 (reason)",
		fScopePaths: "Scope paths",
		noScopePath: "— 无 scope_path 分配 —",
		fAllowedProjects: "可见项目 ID",
		bypassAll: "— bypass: 全部可见 —",
		noVisibleProject: "无可见项目 (allowed-set is empty)",
		emptyTree: "暂无组织架构数据",
		rootLabel: "全部组织",
		tagDefault: "默认",
		tagProjectCount: "{n} 项目",
		truncated: "结果已截断 (>1000 节点)。请使用单层接口分页加载。",
		selectHint: "请在左侧选择一个节点以查看详情",
		dKind: "层级",
		dCode: "代码",
		dTenant: "租户",
		dRegulatory: "监管",
		dFederation: "联邦模式",
		dAddress: "地址",
		dCountry: "国家",
		dRegion: "地区",
		dMission: "使命",
		dProjectCount: "所含项目数",
	},
	auditLog: {
		title: "审计日志",
		refresh: "刷新",
		startDate: "起始时间",
		endDate: "结束时间",
		category: "分类",
		verb: "动作 (verb)",
		targetType: "目标类型",
		outcome: "结果",
		actorUserId: "操作人 ID",
		dataSubjectId: "数据主体 ID (GDPR)",
		targetProjectCode: "项目代码",
		search: "查询",
		reset: "重置",
		empty: "暂无审计日志",
		colTime: "时间",
		colActor: "操作人",
		colApp: "入口",
		colCategory: "分类",
		colVerb: "动作",
		colTarget: "目标",
		colOutcome: "结果",
		colDetail: "详情",
		view: "查看",
		drawerTitle: "审计日志详情",
		eventSection: "事件",
		complianceSection: "合规元数据 (GDPR readiness)",
		integritySection: "完整性 (hash chain)",
		fId: "ID",
		fTime: "时间",
		fActor: "操作人",
		fIp: "IP",
		fApp: "入口",
		fCategory: "分类 / 动作",
		fOutcome: "结果",
		fFailureReason: "失败原因",
		fTarget: "目标",
		fProject: "项目",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "是",
		no: "否",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "关联变更记录",
		loadChange: "加载变更详情",
		fTable: "表/集合",
		fPk: "主键",
		fOp: "操作",
		loadChangeFailed: "加载变更详情失败",
	},
	metaVer: {
		intro: "此页面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a> 的只读视图。版本/历史快照按 spec §3 的三阶段开关推出。规范见 extract/coche/specs/metadata-versioning.md。",
		tabLog: "评估日志 (影子+执行)",
		tabTags: "标签",
		tabAdapters: "格式适配器",
		colTarget: "目标",
		colPriorVer: "原版本",
		colNote: "备注",
		colCode: "编码",
		colTag: "标签",
		colDescription: "描述",
		colCreated: "创建时间",
		colExtensions: "扩展名",
		colName: "名称",
		colEnabled: "启用",
		on: "启用",
		off: "禁用",
	},
	lifecyclePage: {
		intro: "此页面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a> 的只读视图。策略和法律保留的创建走 API;执行严格通过审批工作流(§10.1.3)。规范见 extract/coche/specs/lifecycle-retention.md。",
		tabPolicies: "保留策略",
		tabHolds: "法律保留",
		tabLog: "评估日志 (影子+执行)",
		colTargetType: "目标类型",
		colRetentionDays: "保留天数",
		colAgeAnchor: "年龄锚点",
		colAction: "处置动作",
		colEnabled: "启用",
		colDescription: "描述",
		on: "启用",
		off: "禁用",
		colScope: "范围",
		colTargetId: "目标 ID",
		colReason: "原因",
		colImposed: "施加时间",
		colReleased: "解除时间",
		active: "活跃中",
		colAgeDays: "年龄(d)",
		colRequest: "审批请求",
		colNote: "备注",
	},
	dataSync: {
		title: "数据同步",
		reload: "刷新",
		range7d: "近7天",
		range30d: "近30天",
		range90d: "近90天",
		todayNewPatients: "今日新增患者",
		todayUnits: "今日新增随访单元",
		last7d: "近7天",
		backlog: "待处理单元",
		backlogHint: "已枚举未写入的单元数",
		latestRun: "最近一次运行",
		noRuns: "尚无运行记录",
		noData: "暂无数据",
		chartTitle: "每日更新趋势",
		seriesUnits: "随访单元",
		seriesPatients: "新增患者",
		seriesErrors: "错误数",
		runHistory: "运行历史",
		colBatch: "批次",
		colPhase: "阶段",
		colStatus: "状态",
		colStarted: "开始时间",
		colEnded: "结束时间",
		colDone: "完成",
		colSkip: "跳过",
		colEmpty: "空单元",
		colErrors: "错误",
		colNewPatients: "新增患者",
		colDocuments: "写入文档",
		colNote: "备注",
		detailTitle: "运行详情",
		cacheHits: "缓存命中",
		unrouted: "未路由检查项",
		unmappedEnums: "未匹配枚举值",
		unmappedEnumValues: "被丢弃的枚举取值",
		enumSynonym: "按同义词匹配的取值",
		enumCatchAll: "归入其他类的取值",
		unknownModels: "未知模型",
		multiRecordDropped: "无法存放的多条记录",
		activeFilterSkipped: "跳过的有效行过滤",
		numericPercent: "数值字段：已去除百分号",
		numericDecimal: "数值字段：整数字段收到小数",
		numericThreshold: "数值字段：阈值表述未采纳",
		numericUnit: "数值字段：带单位未采纳",
		numericList: "数值字段：多值未采纳",
		numericQualitative: "数值字段：定性描述未采纳",
		numericThresholdValue: "数值字段：阈值表述明细",
		numericUnitValue: "数值字段：带单位明细",
		numericListValue: "数值字段：多值明细",
		numericQualitativeValue: "数值字段：定性描述明细",
		groupTruncated: "另有 {n} 项未显示",
		scalars: "其他计数",
		colItem: "项目",
		colCount: "次数",
		status: {
			running: "运行中",
			completed: "已完成",
			aborted: "已中止",
			failed: "失败",
		},
	},
	ehealth: {
		uploadReport: "上传收件箱报告（PDF）",
		uploadReportHint: "由 eHR 收件箱打印的处理摘要／异常／重新评级报告。纯图像 PDF 会先 OCR（约 30 秒）。",
		reportDone: "{kind}・{state}・匹配批次 {batches}、记录 {records}",
		reportKind: "类别",
		reportTitle: "标题",
		issuedAt: "发出时间",
		parseState: "读取",
		matchedBatches: "批次",
		matchedRecords: "记录",
		lines: "明细",
		reconcile: "重新核对",
		noReports: "尚未上传任何报告。",
		errorCode: "错误代码",
		errorField: "字段",
		rawLine: "读取原文",
		tabNotifications: "通知",
		poll: "向 eHealth 拉取（GPNH）",
		pollHint: "对外调用：获取自上次窗口以来的同意／主键变更／死亡等通知并应用。全天可用。",
		pollDone: "拉取完成：收到 {received}，应用 {applied}，重复 {duplicates}，未知患者 {unmatched}",
		pendingRepliesTitle: "{n} 条同意通知尚待回复主键核对结果（7 日内）",
		colEvent: "事件",
		changes: "应用的变更",
		reply: "回复",
		replyDue: "期限",
		previewMatch: "预览核对",
		sendReply: "发送回复",
		noReplyDue: "无需回复",
		noNotifications: "尚未应用任何通知。",
		scan: "扫描记录",
		scanHint: "登记本项目的 LABGEN 记录（新增、修改、撤回）。仅本地操作。",
		scanDone: "扫描完成：扫描 {scanned}，登记 {registered}，修改 {amended}，撤回 {withdrawn}",
		transactions: "事务",
		txnDatetime: "事务日期时间",
		outcome: "结果",
		rows: "输出行",
		build: "构建批次",
		buildHint: "将待上传记录组装为已签名、加密的 LABGEN 批次并存于磁盘。点击“上传”前不会发出。",
		buildDone: "已构建 {name}（{mode}）：纳入 {included} 条，排除 {excluded} 条",
		modeAuto: "模式：自动",
		noBatches: "尚未构建批次。",
		colBatchName: "批次（HL7 名称）",
		colParticipants: "患者数",
		colNotes: "构建备注",
		actions: "操作",
		files: "文件",
		upload: "上传（SFTP）",
		checkCollected: "已收取？",
		uploadDone: "已上传——记录转为“已存放”，等待报告",
		remoteDir: "远端目录",
		zipSha: "Zip SHA-256",
		fileKind: "类别",
		fileName: "文件",
		bytes: "字节",
		checksum: "SHA-256",
		open: "打开",
		record: "记录",
		refresh: "刷新",
		colName: "姓名",
		colDob: "出生日期",
		colSex: "性别",
		colConsent: "同意状态",
		colFlags: "标记",
		colQuery: "最近 PMI 查询",
		colEligibleFrom: "可上传起始日",
		unknown: "未知",
		flagDeceased: "已故",
		flagSuspended: "已暂停",
		flagProblem: "问题记录",
		neverQueried: "从未查询",
		pmiSync: "由患者基本信息同步",
		pmiSyncHint: "由“患者基本信息”表单重新推导 PMI 身份行。仅本地操作。",
		pmiSyncDone: "同步完成：扫描 {scanned}，新增 {created}，更新 {updated}，不变 {unchanged}",
		pmiEmpty: "尚无 PMI 身份行——请先在“患者基本信息”表单新增患者，再同步。",
		majorKeys: "主索引键",
		lastDeposit: "最近上传",
		documents: "身份证明文件",
		docType: "类别",
		docNumber: "号码",
		docNumberNorm: "规范化",
		docValidity: "有效性",
		docCurrent: "现行",
		docSuperseded: "已被取代",
		eligibility: "上传资格",
		eligibleYes: "可上传",
		eligibleNo: "不可上传",
		eligibilityNote: "实时依据当前状态及有效期内的最近 PMI 查询计算，从不存为标志。",
		recordDecision: "记录判定",
		pmiQuery: "向 eHealth 查询（PMI Query）",
		pmiQueryHint: "经香港出口对外调用；eHealth 仅在工作日 08:00–18:00（香港时间）响应。",
		pmiQueryDone: "PMI 查询完成",
		keyHistory: "已被取代的主索引键",
		supersededAt: "取代时间",
		surname: "姓氏",
		givenName: "名字",
		reason: {
			OK_JOINING_CONSENT: "eHealth 已确认加入同意",
			NO_EHR_NUMBER: "eHealth 无此主索引键的参与者",
			DECEASED: "患者已登记死亡",
			CONSENT_REVOKED: "对本机构的同意已撤回",
			EMERGENCY_ONLY: "仅紧急访问（只可查看，不可上传）",
			QUERY_STALE: "最近 PMI 查询已过有效期——请重新查询",
			QUERY_UNAVAILABLE: "尚无可用的 PMI 查询结果——请向 eHealth 查询",
		},
		intro: "上传临床数据至香港电子健康记录互通系统（eHRSS）。存放是批次通道，而非逐条保存的 API：记录先在此保存，按数据范畴打包、签名，再经 SFTP 存放，之后由异步报告判定。批次被取走并不等于已被接纳。",
		tabRecords: "记录",
		tabBatches: "批次",
		tabPatients: "PMI 患者",
		tabRegister: "病历登记册",
		registerAllDomains: "全部数据域",
		registerHint: "按患者列出本系统持有的每一份记录，以及把它送交医健通的批次。",
		registerEmpty: "本项目尚未持有临床记录。",
		registerFootnote: "记录先在本系统建立，之后才上传，并注明承载该记录的批次，以证明临床数据由系统直接上传至医健通，而非人工录入。",
		cntPatients: "患者",
		cntRecords: "临床记录",
		cntUploaded: "已上传至医健通",
		cntDomains: "数据域",
		colSummary: "记录",
		colRecordDate: "记录日期",
		colCreatedInEmr: "于本系统建立",
		colUploaded: "上传时间",
		tabReports: "报告",
		tabMapping: "字段映射",
		colRecordKey: "记录键值",
		colDomain: "数据范畴",
		colPatient: "患者",
		colEhrNumber: "eHR 编号",
		colTxn: "事务类别",
		colState: "状态",
		colCreated: "系统内创建时间",
		colDeposited: "存放时间",
		colBatch: "批次",
		colLevel: "评定级别",
		colMode: "模式",
		colTransport: "传输",
		colGenerated: "生成时间",
		colRecordCount: "记录数",
		stateHeld: "保存中",
		stateDeposited: "已存放",
		stateAccepted: "已接纳",
		stateRejected: "已拒绝",
		stateRegraded: "已降级",
		stateWithdrawn: "已撤回",
		depositPending: "等待报告——存放不等于接纳",
		notConfigured: "该项目未配置 eHealth 存放对象（ehealth_hcp_id 为空），只能在此查看记录，无法存放。",
		disabledGlobally: "本部署未启用 eHealth 功能（imles.ehealth.enabled=false）。",
		shadowMode: "影子模式——批次仅生成并记录，不会实际发送。",
		empty: "该项目暂无 eHealth 记录。",
	},
	ingestion: {
		intro: "只读视图。摄取硬化按 spec §3 的三阶段开关推出(Phase A=休眠 / Phase B=影子 / Phase C=enforce)。SFTP 服务器独立 gated 在 <code>imles.ingestion.sftp.enabled</code>。规范见 extract/coche/specs/ingestion-hardening.md。",
		tabChecksum: "校验码 (SHA-256)",
		tabRejections: "拒绝队列",
		tabDedup: "去重表",
		tabSftp: "SFTP 会话",
		hashPlaceholder: "按 SHA-256 查找 (64 hex)",
		colOssFile: "OSS 文件",
		colBytes: "字节",
		colSource: "来源",
		colUploaded: "上传时间",
		colFilename: "文件名",
		colReason: "原因",
		colMode: "影子",
		colDetail: "详细",
		colOriginFileId: "原始文件 ID",
		colReuseCount: "复用次数",
		colFirstSeen: "首次",
		colLastReuse: "最近复用",
		colUser: "用户",
		colAuth: "认证",
		colOpened: "开始",
		colClosed: "结束",
		colUploads: "上传数",
		colTotalBytes: "总字节",
		colCloseReason: "关闭原因",
	},
	dbConfig: {
		title: "数据库配置",
		step1: "选择数据库模型",
		step2: "选择输出形式",
		step3: "配置表单/文档",
		step4: "配置字段",
		selectedOutput: "选定输出形式",
		structuredForm: "结构化表单",
		structuredF1: "· 按照自定义的表单导出数据",
		advFilter: "· 支持高级检索",
		univariate: "· 支持单变量统计分析",
		crfExport: "· 根据数据生成CRF表格，可导出PDF/Word文档",
		defaultForm: "默认表单",
		defaultF1: "· 按照默认结构显示表单",
		formConfigTitle: "项目表单配置",
		formName: "项目表单名称",
		formCode: "项目表单编码",
		formOrder: "项目表单排序",
		visible: "是否显示",
		formModelConfigTitle: "项目表单模型配置",
		selectModel: "选择模型",
		newModel: "新增模型",
		colIndex: "序号",
		modelCode: "模型编码",
		modelName: "模型名称",
		modelDomain: "模型领域",
		modelOrder: "模型排序",
		modelConfigTitle: "项目模型配置",
		modelNameLabel: "项目模型名称",
		modelCodeLabel: "*项目模型编码",
		modelCodeLabelReq: "项目模型编码",
		dontModify: "非必要情况请勿修改",
		deletionMode: "删除方式",
		logical: "逻辑",
		physical: "物理",
		modelDescription: "模型描述",
		showNoteInput: "显示注释输入框",
		note: "注释",
		sceneType: "场景类型",
		sceneDefault: "默认场景",
		sceneTable: "表格场景",
		sceneTableDialog: "表格弹窗场景",
		sceneList: "列表场景",
		uploadAttachment: "上传附件",
		on: "开",
		off: "关",
		saveModelAttrs: "保存模型属性",
		editFields: "编辑字段",
		modelFieldConfigTitle: "项目模型字段配置",
		previous: "上一步",
		next: "下一步",
		selectedInfo: "当前选定信息",
		availableInfo: "可选信息内容",
		codeFormatHint: "请输入字母、数字或下划线",
		selectRowFirst: "请选择一条数据后添加",
		enterModelName: "请输入项目模型名称",
		enterModelCode: "请输入项目模型编码",
		modelCodeFormat: "模型编码只能包含字母、数字和下划线",
		saveFormFirst: "请先保存表单信息",
		modelCodeExists: "该模型编码已存在",
	},
	fieldList: {
		colFieldOrder: "字段排序",
		colIntegrityScore: "完整度分",
		colFieldCode: "字段编码",
		colFieldName: "字段名称",
		colFieldType: "字段类型",
		colVisible: "是否显示",
		colEditable: "是否可编辑",
		colRequired: "是否必填",
		colDictValue: "字典值",
		addField: "添加字段",
		refField: "引用字段",
		dlgEdit: "编辑",
		dlgAdd: "添加",
		order: "排序",
		noSorting: "不排序",
		reservedHint: "以下字段编码具有特殊含义，会自动映射到患者信息表：",
		colMeaning: "含义",
		colDescription: "说明",
		reservedUniqueNote: "其中 <b>card_id</b>、<b>inpatient_id</b>、<b>outpatient_id</b> 具有唯一性约束，同一项目内不允许重复值，可用于防止重复录入患者。",
		fieldNameZh: "字段中文名",
		fieldNameEn: "字段英文名",
		fieldAlias: "字段别名",
		tailLabel: "尾部标签",
		refRange: "参考范围",
		refMin: "下限",
		refMax: "上限",
		refRangeHint: "仅数值类型；越界时标记异常，不阻止保存",
		refRangeInvalid: "参考范围下限不能大于上限",
		fieldDesc: "字段解释",
		controlsVisibility: "是否控制显示",
		controlledFields: "受控字段",
		optionCode: "选项编码",
		optionName: "选项名称",
		controlledFieldCount: "受控字段数量",
		controlledModelCount: "受控模型数量",
		inFormEvent: "表单内事件",
		inModelEvent: "模型内事件",
		inModelClickEvent: "模型内click事件",
		showNoteInput: "显示注释输入框",
		note: "注释",
		subFieldList: "子字段列表",
		refList: "引用列表",
		selectExisting: "选择已有字段",
		colIndex: "序号",
		colModifiedBy: "修改人",
		colModifiedAt: "修改时间",
		dlgSubEdit: "子字段编辑",
		dlgSubAdd: "子字段添加",
		existingFieldList: "已有字段列表",
		fieldControlled: "字段受控",
		modelControlled: "模型受控",
		colFieldId: "字段ID",
		colModelId: "模型ID",
		colModelCode: "模型编码",
		colModelName: "模型名称",
		refSaved: "引用关系保存成功",
		convertedToSub: "已修改为子字段",
		none: "无",
		reserved: {
			name: { n: "姓名", d: "患者姓名" },
			gender: { n: "性别", d: "0=女, 1=男" },
			age: { n: "年龄", d: "患者年龄" },
			birthday: { n: "出生日期", d: "患者生日" },
			phone: { n: "手机号", d: "联系电话" },
			idNum: { n: "身份证号", d: "身份证号码" },
			cardId: { n: "住院卡号", d: "唯一约束，不可重复" },
			inpatientId: { n: "门诊号", d: "唯一约束，不可重复" },
			outpatientId: { n: "住院号", d: "唯一约束，不可重复" },
			admissionTime: { n: "入院时间", d: "日期类型" },
			enrollmentTime: { n: "入组时间", d: "日期类型" },
			diagnosis: { n: "诊断", d: "诊断信息" },
			doctorId: { n: "医生ID", d: "关联医生" },
			doctorName: { n: "医生名字", d: "关联医生姓名" },
			hospitalName: { n: "所属医院", d: "医院名称" },
			status: { n: "患者状态", d: "如：入组、出组" },
			statusCode: { n: "状态编码", d: "状态对应编码" },
		},
	},
	customColumn: {
		title: "设置自定义列",
		searchFieldPh: "输入检索字段的名称",
		name: "名称",
		order: "排序",
		visible: "是否显示",
		description: "描述",
		propertyPath: "属性路径",
		selectProperty: "请选择属性",
		colIndex: "序号",
	},
	piiRule: {
		title: "PII 规则配置",
		currentProject: "当前项目",
		refresh: "刷新",
		readonly: "只读出口脱敏 (read-side anonymisation)",
		readonlyDesc: "规则仅在数据导出与队列检索路径上生效；落盘数据不变。默认 KEEP 表示原样返回。具备 pii.unmask 权限的角色可绕过脱敏 (绕过会被记入审计)。",
		addRule: "新增规则",
		preview: "规则预览",
		saveAll: "保存全部修改",
		empty: "尚未配置任何 PII 规则",
		colField: "字段编码 (field_code)",
		colMode: "脱敏方式",
		colExample: "样例",
		colNote: "备注",
		colOperation: "操作",
		actDelete: "删除",
		modeKeep: "保留原值 (默认)",
		modeMask: "掩码",
		modeRedact: "占位符替换",
		modePseudonym: "项目内确定性化名",
		modeHash: "SHA-256 哈希 (12 hex)",
		modeSuppress: "完全删除字段",
		modeGeneralise: "分桶/分级泛化",
		previewMissingInput: "请填写字段与脱敏方式。",
		draftMissingFieldCode: "新增的规则必须填写字段编码。",
		saveSummary: "已保存 {saved} 条 · 删除 {deleted} 条",
	},
	analytics: {
		overviewTitle: "分析概览",
		datasetTitle: "数据集",
		encodingTitle: "字段编码",
		selectionTitle: "字段筛选",
		algorithmTitle: "算法执行",
		reportTitle: "统计报告",
		researchOverviewTitle: "分析概览",
		libraryTitle: "研究资料",
		topicsTitle: "课题推荐",
		workbenchTitle: "分析工作台",
		refresh: "刷新数据",
		empty: "暂无分析数据",
		statSamples: "样本数",
		statFields: "字段数",
		statAnalyses: "分析数",
		recentAnalyses: "最近分析",
		colName: "分析名称",
		colType: "类型",
		colCreatedAt: "创建时间",
		colOperation: "操作",
		actView: "查看",
		viewDetail: "查看详情",
		typeAlgorithm: "算法执行",
		typeReport: "统计报告",
		errorProject: "项目信息未找到",
		errorFetch: "获取数据失败",
	},
	clinic: {
		operationOverview: "运营概览",
		appointments: "加号申请",
		checkins: "报到列表",
		chatHistory: "聊天历史",
		users: "门诊用户管理",
		refresh: "刷新",
		today: "今日",
		last7d: "近7天",
		last30d: "近30天",
		last90d: "近90天",
		custom: "自定义",
		dateSep: "至",
		startDate: "开始日期",
		endDate: "结束日期",
		kpiTotalUsers: "累计用户",
		kpiNewUsers: "期内新增用户",
		kpiActiveUsers: "活跃用户",
		kpiDeactivated: "已停用账号",
		kpiSnapshot: "当前快照",
		kpiMessages: "期内消息总数",
		kpiConversations: "期内对话总数",
		kpiUploads: "期内上传病历数",
		kpiFollowupMessages: "期内随访消息",
		recentRegistrations: "近期注册",
		// 门诊用户管理 list
		searchPlaceholder: "搜索昵称 / 手机号 / openid",
		searchBtn: "搜索",
		showDeleted: "显示已注销账号",
		totalCount: "共 {n} 条",
		emptyUsers: "暂无用户",
		colUser: "用户",
		colContact: "联系方式",
		colLoginType: "登录方式",
		colLastLogin: "最近登录",
		colStatus: "状态",
		colRemark: "备注",
		colActions: "操作",
		statusDeleted: "已注销",
		statusActive: "已开通",
		statusDisabled: "已停用",
		loginWechat: "微信",
		loginPassword: "账号",
		loginBoth: "双绑",
		internalFlag: "可体验新功能",
		disable: "停用",
		restore: "恢复",
		disableTitle: "停用账号",
		restoreTitle: "恢复账号",
		disableConfirm: "即将{action}用户 {name}。",
		disableNote: "停用后该用户登录将提示「您的账号暂无访问权限」，无法继续使用，但已有的数据保留。",
		reasonLabel: "原因（可选，会展示给用户）",
		confirm: "确定",
		cancel: "取消",
		save: "保存",
		opSuccess: "操作成功",
		opFailed: "操作失败",
		loadFailed: "加载失败",
		internalOn: "已设为可体验新功能",
		internalOff: "已取消体验权限",
		viewDetail: "详情",
		// 用户详情 page
		userDetail: "用户详情",
		backToList: "返回列表",
		profile: "用户资料",
		loginCount: "登录次数",
		createdAt: "注册时间",
		lastLoginIp: "登录IP",
		patientTimelines: "患者时间线",
		noPatients: "暂无患者档案",
		correctionHint: "时间线由系统自动生成，医生可修正；用户提交的原始聊天与资料不可编辑。",
		tabConversations: "会话记录",
		tabAppointments: "加号申请",
		tabCheckins: "报到记录",
		tabAssessments: "评估结果",
		convTitle: "会话标题",
		convTheme: "话题",
		convPending: "待回复",
		convMessages: "消息数",
		convLastActive: "最近活动",
		patient: "患者",
		// 患者时间线 component
		patientInfo: "患者信息",
		patientName: "姓名",
		patientGender: "性别",
		patientDob: "出生日期",
		hospitalCards: "就诊卡",
		baseline: "基线",
		followUps: "随访记录",
		viewSource: "查看来源",
		assessmentSource: "来源：问卷评估",
		timelineMissing: "未找到患者时间线数据",
		correctedBadge: "医生已修正",
		correctedAt: "修正时间",
		editEvent: "编辑",
		deleteEvent: "删除",
		editEventTitle: "修正随访事件",
		eventDate: "日期",
		eventType: "事件类型",
		removeField: "删除字段",
		undoRemove: "撤销删除",
		complexFields: "复杂字段",
		complexFieldsNote: "结构化字段，以 JSON 格式编辑；保存前会校验格式。",
		invalidJson: "{key} 的 JSON 格式有误，请检查后再保存",
		addField: "新增字段",
		fieldKey: "字段名",
		fieldValue: "值",
		add: "添加",
		reservedFieldKey: "该字段为系统保留字段",
		duplicateFieldKey: "字段已存在",
		noChanges: "未检测到修改",
		correctionSaved: "修正已保存",
		correctionFailed: "操作失败，请稍后重试",
		deleteEventTitle: "删除确认",
		deleteEventConfirm: "确认删除该随访事件（{type} {date}）？此操作不可撤销。",
		eventDeleted: "已删除",
	},
	discern: {
		title: "AI识别列表",
		uploader: "上传用户：",
		userType: "用户类型：",
		identifyStatus: "识别状态：",
		confirmStatus: "确认状态：",
		input: "请输入",
		select: "请选择",
		userDoctor: "医生",
		userPatient: "患者",
		userSys: "管理员",
		statusUnfinished: "未完成",
		statusFinished: "已完成",
		statusPending: "待确认",
		statusConfirmed: "已确认",
		searchBtn: "查 询",
		resetBtn: "重 置",
		qrCode: "二维码",
		batchUpload: "批量上传",
		colIndex: "序号",
		colUploader: "上传用户",
		colUserType: "用户类型",
		colProject: "项目名称",
		colFileCount: "图片数量",
		colUploadTime: "上传时间",
		colIdentifyStatus: "识别状态",
		colIdentifyTime: "识别时间",
		colConfirmStatus: "确认状态",
		colConfirmUser: "确认用户",
		colConfirmTime: "确认时间",
		colOperation: "操作",
		actView: "查看",
		actConfirm: "确认",
		viewTitle: "AI识别详情",
		batchUploadTitle: "批量上传",
		dropFiles: "将文件拖到此处，或",
		clickUpload: "点击上传",
		fileTip: "仅支持 JPG/PNG，单文件不超过 10MB",
		startUpload: "开始上传",
	},
	governance: {
		title: "审批收件箱",
		myTitle: "我的申请",
		refresh: "刷新",
		colId: "申请ID",
		colType: "类型",
		colRequester: "申请人",
		colCreatedAt: "申请时间",
		colStatus: "状态",
		colOperation: "操作",
		actView: "查看",
		actApprove: "通过",
		actReject: "驳回",
		statusPending: "待审批",
		statusApproved: "已通过",
		statusRejected: "已驳回",
		statusCancelled: "已取消",
		drawerTitle: "申请详情",
		approve: "通过",
		reject: "驳回",
		comment: "审批意见",
		commentPh: "请输入审批意见",
		noPendingStep: "没有待审批步骤",
		emptyCommentConfirm: "驳回建议填写理由,确定空备注提交吗?",
		confirmTitle: "确认",
		toastApproved: "已通过",
		toastRejected: "已驳回",
		quickConfirmBody: "{action} 申请 #{id}?",
		quickConfirmTitle: "确认操作",
	},

	consent: {
		admin: {
			tabTemplates: "模板管理",
			tabSignatures: "医生签名",
			noProject: "缺少项目参数，请从项目管理页进入。",
			noPermission: "您没有知情同意书模板管理权限，请联系系统管理员。",
			templateHint: "同一类型下只能有一个已发布版本；已发布的模板不可修改，如需调整请新建版本。",
			templateEmpty: "该项目还没有知情同意书模板",
			newTemplate: "新建模板",
			colFamily: "类型",
			colName: "名称",
			colVersion: "版本",
			colStatus: "状态",
			colSource: "来源",
			colPages: "页数",
			colUpdated: "更新时间",
			colActions: "操作",
			status: {
				DRAFT: "草稿",
				ACTIVE: "已发布",
				RETIRED: "已停用",
			},
			actZones: "标注",
			actPreview: "预览",
			actEdit: "编辑",
			actPublish: "发布",
			actRetire: "停用",
			actNewVersion: "新版本",
			actDelete: "删除",
			familyHint: "同一份同意书的类型标识，例如 F2F（面对面）、PHONE（电话）",
			versionHint: "例如 V3.0a",
			sourcePdf: "PDF 上传",
			sourceText: "纯文本",
			file: "模板文件",
			chooseFile: "选择 PDF",
			fileHint: "仅支持未加密的 PDF 文件",
			textBody: "正文",
			textHint: "系统据此生成 PDF，并自动追加一页标准签名页",
			remark: "备注",
			effectiveDate: "生效日期",
			effectiveDatePlaceholder: "选择日期",
			editMeta: "编辑模板信息",
			createIncomplete: "请填写类型、名称与版本",
			needPdf: "请选择 PDF 模板文件",
			needText: "请填写模板正文",
			createDone: "模板已创建（草稿）",
			saveDone: "已保存",
			publishConfirm: "确定发布「{name}」？同类型下已发布的版本将自动停用。",
			publishDone: "模板已发布",
			retireConfirm: "确定停用「{name}」？停用后签署页将不再显示该版本。",
			retireDone: "模板已停用",
			newVersionBody: "基于 {version} 复制为新草稿，请输入新的版本号",
			versionRequired: "请输入版本号",
			newVersionDone: "新版本草稿已创建",
			deleteConfirm: "确定删除「{name}」{version}？此操作不可恢复。",
			deleteDone: "模板已删除",
			zoneTitle: "标注签名区域",
			zoneList: "区域列表",
			zoneEmpty: "还没有标注任何区域",
			zoneNoSelection: "在左侧页面上拖拽以新建区域，或点击已有区域进行编辑",
			zoneReadonly: "只读",
			zoneReadonlyHint: "已发布/已停用的模板不可修改标注，如需调整请新建版本",
			zoneDrawHint: "拖拽空白处新建区域；拖拽方框移动；拖拽角点缩放；Delete 删除选中区域",
			zoneDirty: "有未保存的修改",
			zoneSave: "保存标注",
			zoneSaved: "标注已保存",
			zoneDiscardTitle: "放弃未保存的修改？",
			zoneDiscardBody: "标注尚未保存，关闭后修改将丢失。",
			zoneKey: "标识 (key)",
			zoneKeyHint: "小写字母、数字与下划线，1-32 位；签署时用于匹配签名图片",
			zoneKeyInvalid: "只允许小写字母、数字与下划线，1-32 位",
			zoneKeyInvalidAt: "区域标识「{key}」不合法：只允许小写字母、数字与下划线，1-32 位",
			zoneKeyDuplicate: "区域标识「{key}」重复",
			zoneType: "类型",
			zoneRole: "角色",
			zoneLabel: "显示名称",
			zoneSource: "自动填充",
			zonePage: "页码",
			zoneFormat: "格式",
			zoneFormatHint: "例如 yyyy年MM月dd日；日期类区域必填",
			zoneRect: "位置与大小（页面比例 0-1）",
			zoneRectHint: "x/y 为左上角坐标，w/h 为宽高，均为页面宽高的比例",
			zoneRequired: "必填",
			zoneMask: "覆盖底纹",
			zoneMaskHint: "签署时先涂白该区域，用于覆盖预印文字",
			zoneDelete: "删除该区域",
			prevPage: "上一页",
			nextPage: "下一页",
			type: {
				SIGNATURE: "签名",
				DATE: "日期",
				DATETIME: "日期时间",
				DATETIME_RANGE: "时间区间",
				TEXT: "文本",
				CHECKBOX: "勾选框",
			},
			source: {
				none: "不自动填充",
				patient_no: "研究参与者筛选号",
				patient_name: "研究参与者姓名",
				doctor_name: "研究人员姓名",
				signed_date: "签署日期",
			},
			signatureHint: "为项目成员维护签名图片；签署时「研究人员」区域使用登录人自己的签名。",
			memberEmpty: "该项目还没有成员",
			colNickname: "姓名",
			colUsername: "账号",
			colSignature: "签名",
			noSignature: "未设置",
			actUpload: "上传",
			actDraw: "手写",
			actDeleteSignature: "删除",
			chooseImage: "选择图片",
			uploadHint: "建议使用背景透明的 PNG；若为白底扫描件，请勾选「去除白底」。",
			needImage: "请选择签名图片",
			needDrawing: "请先完成签名",
			signatureSaved: "签名已保存",
			signatureDeleted: "签名已删除",
			deleteSignatureConfirm: "确定删除 {name} 的签名？",
		},
		panel: {
			title: "知情同意书",
			sign: "签署知情同意书",
			empty: "暂无签署记录",
			colTemplate: "模板",
			colVersion: "版本",
			colSignedDate: "签署日期",
			colDoctor: "研究人员",
			colStatus: "状态",
			view: "查看",
			download: "下载",
			voidAction: "作废",
			voidPromptTitle: "作废签署记录",
			voidPromptBody: "作废后该记录不再作为有效知情同意，文件仍会保留。请填写作废原因（{template}）。",
			voidReasonPlaceholder: "请填写作废原因，200 字以内",
			voidReasonRequired: "请填写作废原因",
			voidReasonTooLong: "作废原因不能超过 200 字",
			voidDone: "已作废",
		},
		status: {
			SIGNED: "已签署",
			VOID: "已作废",
		},
		role: {
			PATIENT: "研究参与者",
			DOCTOR: "研究人员",
			GUARDIAN: "监护人",
			WITNESS: "公正见证人",
			OTHER: "其他信息",
		},
		dialog: {
			title: "签署知情同意书",
			stepTemplate: "选择模板",
			stepRead: "阅读全文",
			stepSign: "签名",
			prev: "上一步",
			next: "下一步",
			submit: "确认签署",
			selectTemplateHint: "请选择本次需要签署的知情同意书版本",
			readHint: "请与研究参与者一起阅读全文；滚动至最后一页后方可继续。",
			readEnd: "已到全文末尾",
			pageOf: "第 {n} 页 / 共 {total} 页",
			signedDate: "签署日期",
			signedDateHint: "默认为今天，可修改",
			followsSignedDate: "跟随上方签署日期",
			rangeStart: "开始时间",
			rangeEnd: "结束时间",
			noZones: "该模板尚未标注签名区域，请联系项目管理员。",
			optionalSection: "如适用",
			expand: "展开",
			collapse: "收起",
			signature: "签名",
			submitSuccess: "签署成功",
			templateLoadFailed: "模板加载失败",
			popupBlocked: "签署成功。浏览器拦截了新窗口，可在下方列表中点击「查看」打开。",
		},
		doctor: {
			stored: "已存签名",
			redraw: "重新签名",
			useStored: "使用已存签名",
			saveAsMine: "保存为我的签名",
			noStored: "您还没有保存签名，可勾选后保存本次签名。",
		},
		pad: {
			tabDraw: "手写",
			tabUpload: "上传图片",
			tabType: "输入姓名",
			drawHint: "请在下方区域内签名",
			upload: "选择图片",
			whiteToAlpha: "去除白底",
			namePlaceholder: "请输入姓名",
			undo: "撤销",
			clear: "清除",
			required: "必填",
			optional: "选填",
			imageFailed: "图片读取失败",
			notImage: "请选择图片文件",
		},
		validate: {
			signatureRequired: "请完成「{label}」签名",
			valueRequired: "请填写「{label}」",
			rangeInvalid: "「{label}」的结束时间不能早于开始时间",
		},
	},
	basicInfo: {
		doctor: "负责医生",
		maskedDoctor: "***医生",
		hospital: "所属机构",
		maskedHospital: "****医院",
		input: "请输入",
		enrollDate: "入组日期",
		select: "请选择",
		status: "入组状态",
		diagnosis: "诊断",
		diagnosisPh: "请输入诊断",
	},
	patientInfo: {
		patientNo: "患者编号",
		randomNo: "随机号",
		name: "姓名",
		gender: "性别",
		age: "年龄",
		ageUnit: "岁",
		dob: "出生日期",
		phone: "联系电话",
		idNumber: "证件号",
		project: "所属项目",
		enrollDate: "入组日期",
		status: "入组状态",
		doctor: "负责医生",
		hospital: "所属机构",
	},
	followupRecord: {
		recordTitle: "随访记录",
		newRecord: "新增随访",
		emptyHint: "暂无随访记录",
		actView: "查看",
		actEdit: "编辑",
		actDelete: "删除",
		visitName: "访视",
		dueDate: "应到日期",
		actualDate: "实际日期",
		statusPending: "未随访",
		statusOverdue: "已超窗",
		statusDone: "已随访",
		confirmCancel: "确认取消该次随访？",
		menuSelect: "模板选择",
		menuDelete: "删除模板",
		menuAdd: "新增非计划随访",
		dialogSelectTitle: "选择随访计划模板",
		dialogAddTitle: "新增非计划随访",
		fieldProjectName: "项目名称：",
		fieldTemplate: "选择模板：",
		fieldStart: "起始日期：",
		select: "请选择",
		datePh: "选择随访日期",
		ruleTemplate: "请选择模板",
		ruleStart: "请选择起始时间",
		generatePlan: "生成计划",
		confirmDelete: "删除后不可恢复，确认删除？",
		confirmDeleteOne: "确定删除该条随访记录？删除后不可恢复。",
		dialogTipTitle: "提示",
		deleteSuccess: "删除成功",
		dialogEditTitle: "编辑随访记录",
		fieldVisitName: "随访名称",
		fieldVisitType: "随访类型",
		typePlan: "计划随访",
		typeNoPlan: "非计划随访",
		fieldPlan: "随访计划",
		fieldConfig: "计划节点",
		namePh: "请输入随访名称",
		rulePlan: "请选择随访计划",
		ruleConfig: "请选择计划节点",
		editSuccess: "修改成功",
	},
	upgradation: {
		dialogTitle: "升级会员",
		selectLevel: "选择会员等级",
		level: "等级",
		duration: "时长",
		monthly: "{n}个月",
		yearly: "{n}年",
		price: "价格",
		discount: "认证用户享 5 折",
		payNow: "立即支付",
		paySuccess: "支付成功",
		payFailed: "支付失败",
		qrTip: "请使用微信扫码支付",
	},
	fileUpload: {
		click: "点击上传",
		drop: "或将文件拖到此处",
		tip: "支持 JPG / PNG / PDF",
		preview: "预览",
		download: "下载",
		remove: "删除",
		removeConfirm: "确认移除该文件？",
		uploading: "上传中…",
		uploaded: "已上传",
		uploadFailed: "上传失败",
		uploadFailedWithReason: "上传被拒绝：{reason}",
		duplicateRejected: "重复文件被拒绝——此文件已为该患者上传过。",
		exceed: "文件数量超出限制",
		view: "查看",
		upload: "上传",
		dialogUploadTitle: "上传文件",
		dialogViewTitle: "查看文件",
		cancelUpload: "取消上传",
		selectFile: "文件上传",
		dragHint: "拖拽文件至此，或",
		clickToSelect: "选择文件上传",
		aiOcr: "AI识别",
		submitted: "已提交识别",
		selectAll: "全选",
		selected: "已选 {n}",
		emptyData: "暂无数据",
	},
	patientList: {
		patientNoOrName: "患者编号/姓名：",
		enrollDate: "入组日期：",
		startDate: "开始时间",
		endDate: "结束时间",
		center: "所属中心：",
		searchPlaceholder: "请输入",
		searchKeyword: "请输入关键字",
		searchBtn: "查 询",
		resetBtn: "重 置",
		colIndex: "序号",
		colCompleteness: "完整度",
		colOperation: "操作",
		dragReorderTip: "拖动调整列顺序（仅本机生效）",
		actDetail: "患者详情",
		actFollowup: "随访详情",
		actImaging: "影像",
		actImagingWorkspace: "影像工作台",
		actTimeSeries: "时序",
		actDelete: "删除数据",
		deleteSuccess: "删除成功",
		deleteConfirm: "确认删除此患者数据？该操作不可撤销。",
		deleteTitle: "提示",
		add: "添加患者",
		export: "导出",
		batchEnroll: "批量入组",
		import: "导入",
		advancedFilter: "高级筛选",
		colPatientNo: "患者编号",
		colName: "姓名",
		colGender: "性别",
		colBirth: "出生日期",
		colAge: "年龄",
		colEnrollDate: "入组日期",
		colCenter: "所属中心",
		genderMale: "男",
		genderFemale: "女",
		genderUnknown: "未知",
		ageYears: "岁",
		viewSource: "溯源",
	},
	patientDetail: {
		add: "添加患者",
		edit: "编辑患者",
		fileView: "患者文件视图",
		basicInfo: "基本信息",
		save: "保存",
		saveDraft: "暂存",
		discard: "放弃修改",
		nextForm: "下一步",
		prevForm: "上一步",
		visitRecords: "就诊记录",
		followups: "随访记录",
		documents: "影像/文件",
		newVisit: "新增就诊",
		fieldRequired: "请输入",
	},
	retrieval: {
		title: "数据检索",
		exportTitle: "数据检索-导出",
		searchPlaceholder: "请输入关键字",
		newQuery: "新建查询",
		runQuery: "运行查询",
		exportResult: "导出结果",
		conditions: "筛选条件",
		results: "查询结果",
		colIndex: "序号",
		colName: "查询名称",
		colCreatedAt: "创建时间",
		colOperation: "操作",
		actView: "查看",
		actEdit: "编辑",
		actDelete: "删除",
		actExport: "导出",
		actRun: "运行",
		deleteGroup: "删除分组",
		selectValues: "请选择值",
		enterValue: "请输入值",
		fieldTreeFailed: "字段列表加载失败",
		selectAnalysisField: "请先选择要分析的字段",
		condition: {
			is: "等于",
			ne: "不等于",
			gt: "大于",
			gte: "大于等于",
			lt: "小于",
			lte: "小于等于",
			regex: "全部模糊匹配",
			exists: "是否存在",
			in: "在指定的数组中",
			nin: "不在指定的数组中",
			all: "数组包含所有指定的元素",
			yes: "是",
			no: "否",
			and: "符合所有条件",
			or: "符合任意条件",
			nor: "均不符合条件",
		},
		stats: {
			title: "检索结果统计",
			chart: "统计图",
			chartTypePlaceholder: "请选择分析图形",
			startDate: "开始日期",
			endDate: "结束日期",
			startDatePlaceholder: "请选择开始日期",
			endDatePlaceholder: "请选择结束日期",
			barChart: "柱状图",
			pieChart: "饼状图",
			sampleSize: "样本量",
			max: "最大值",
			min: "最小值",
			median: "中位数",
			avg: "平均数",
		},
		exportPage: {
			searchConditions: "检索条件",
			saveAsTemplate: "保存为模板",
			resultList: "检索结果列表",
			colPatientNo: "患者编号",
			colPatientName: "患者姓名",
			colEnrollmentDate: "入组日期",
			colAge: "年龄",
			colBirthday: "出生日期",
			colDoctor: "负责医生",
			colEnrollmentStatus: "入组状态",
			colLastUpdated: "最近更新日期",
			colUpdatedBy: "最近更新用户",
			colDataManage: "数据管理",
			patientDetail: "患者详情",
			followUpDetail: "随访详情",
			templateNamePlaceholder: "请输入模板名称",
			templateNameRequired: "请输入模板名称",
			templateSaved: "保存模板成功",
			joinSubProject: "入组子项目",
			existingSubProjects: "已有子项目",
			subProjectName: "子项目名称",
			projectStartDate: "项目启动日期",
			projectEndDate: "项目结束日期",
			enrolledCount: "已入组人数",
			actEnrol: "入组",
			addSubProject: "新增子项目",
			basicInfo: "基本信息",
			rootProjectName: "根项目名称",
			projectLeader: "项目负责人",
			leaderUnit: "负责人单位",
			projectGoal: "项目目标",
			selectSubProject: "请选择子项目",
		},
		exportDialog: {
			title: "数据导出",
			exportAll: "导出全部表单和模型",
			exportPartial: "导出部分表单和模型",
			selectForms: "请选择您要导出的表单和模型",
			approvalConfirm: "本项目导出需经审批通过后方可下载。是否提交导出申请?",
			approvalTitle: "需要审批",
			submitRequest: "提交申请",
			requestId: "申请编号",
			status: "状态",
			requestPending: "导出申请已提交,等待审核人审批。可在“我的申请”中查看进度。",
			requestSubmitted: "导出申请已提交",
			goToMyRequests: "前往我的申请",
		},
	},
	analysis: {
		title: "数据分析",
		runAnalysis: "执行分析",
		results: "分析结果",
		exportResult: "导出报告",
		emptyHint: "请先选择字段并执行分析",
	},
	projectManage: {
		title: "项目列表",
		searchPlaceholder: "请输入项目名称",
		clearModelCache: "清除模型缓存",
		clearModelCacheConfirm: "确认清除所有模型缓存？清除后所有用户首次加载会稍慢。",
		clearModelCacheTip: "提示",
		clearModelCacheSuccess: "缓存已清除，共清除 {n} 条缓存",
		newProject: "新建项目",
		colProjectId: "项目ID",
		colProjectName: "项目名称",
		colProjectLeader: "项目负责人",
		colProjectTerm: "项目周期",
		colFollowupData: "随访数据",
		colViewInfo: "视图信息",
		colMainCenter: "主中心",
		colOperation: "操作",
		actEdit: "编辑项目",
		actScene: "应用场景",
		actDatabase: "数据库配置",
		actFollowup: "随访设置",
		actPermissions: "人员权限",
		actSubCenter: "分中心管理",
		actSubProject: "子项目管理",
		actSchema: "架构初始生成",
		actAgent: "Agent配置",
		actMetadataHistory: "元数据历史",
		actLifecycle: "生命周期与留存",
		actPiiRule: "PII规则配置",
		actConsent: "知情同意书",
		grpSetup: "设置",
		grpData: "数据",
		grpGovernance: "治理",
		grpStructure: "结构",
		lostFollowups: "丟失计划随访条数 {n}",
		fixData: "修复数据",
		patientCount: "就诊人:{p} ; 视图行: {v};",
		patientViewMismatch: "---存在差异---",
		buildStatus: "构建状态:{s} ;",
		buildBusy: "视图构件中",
		buildIdle: "当前无任务",
		startTime: "开始时间:{t};",
		endTime: "结束时间:{t};",
		execResult: "执行结果:{r};",
		execSuccess: "成功",
		execFailed: "失败",
		rebuildView: "重建视图",
		appendView: "修补视图",
		recalcCompleteness: "重算完整度",
		opSent: "请求已发送",
		recalcDone: "重算完成，共处理 {n} 位患者",
		dialogBaseTitle: "基本信息",
		dialogSceneTitle: "应用场景",
		fieldProjectName: "项目名称",
		fieldProjectCode: "项目编码",
		fieldProjectLeader: "项目负责人",
		fieldLeadCenter: "牵头单位",
		fieldStartDate: "项目启动日期",
		fieldEndDate: "项目结束日期",
		fieldTarget: "项目目标",
		fieldLeaderUnit: "负责人单位",
		fieldCompanyLogo: "公司Logo（横版）",
		fieldSquareLogo: "方形Logo（图标）",
		placeholderSelect: "请选择",
		fieldSpecialty: "专科",
		fieldDisease: "疾病",
		fieldSoftwareEnv: "软件环境",
		envWeb: "web",
		envDoctor: "医生小程序",
		envPatient: "患者小程序",
		fieldLoginUrl: "项目登录页URL",
		fieldLoginName: "项目登录页名称",
		fieldLoginImage: "项目登录页图片",
		searchPlaceholderRemote: "请输入关键字",
	},
	equity: {
		accountInfo: "账号信息",
		username: "用户名：",
		realNameAuth: "实名认证：",
		modify: "修改",
		notAuthHint: "当前您未完成信息认证，无法享受五折优惠",
		goAuth: "去认证",
		levelExpire: "会员等级有效期：{date}",
		upgrade: "去升级会员",
		memberRights: "会员权益",
		categoryProjectMgmt: "项目管理",
		categoryAiCollect: "AI数据采集功能",
		categoryAiAnalysis: "AI数据分析功能",
		categoryIp: "知识产权服务",
		categoryResearch: "科研项目服务",
		rightCreateProject: "新建项目",
		rightCustomForm: "自定义表单",
		rightFollowup: "随访管理",
		rightEnrollment: "入组状态管理",
		rightSubProject: "子项目管理",
		rightUnivariate: "单变量统计",
		rightSearch: "数据检索",
		rightExport: "数据导出",
		rightHistorical: "历史数据入组新项目",
		rightAutoEnroll: "新数据自动纳排",
		rightCrfGen: "自动生成CRF表",
		rightCrfFill: "自动填充CRF表",
		rightPathology: "自动生成病理报告",
		rightFollowupChat: "交互式患者随访",
		rightAiSearch: "AI数据检索",
		rightAiStat: "AI数据统计",
		rightAiExport: "AI数据筛选导出",
		rightAiEnroll: "AI纳排管理",
		rightIpFile: "知识产权申报",
		rightJointProject: "联合项目申报",
		basicMember: "基础会员",
		smartMember: "智慧会员",
		joint1Software: "免费申请联合软著1项",
		joint2Software: "免费申请独立软著2项",
		jointAiProject: "可联合申报医疗人工智能项目",
		currentLevel: "当前等级",
		dialogAuthTitle: "信息认证",
	},
	order: {
		searchPlaceholder: "请输入订单编号",
		orderList: "订单列表",
		colIndex: "序号",
		colOrderNo: "订单号",
		colPaymentTime: "交易时间",
		colPaymentFees: "交易金额",
		colPaymentMethod: "支付方式",
		methodWechat: "微信",
		colContent: "交易内容",
		colStatus: "当前状态",
		colInvoiceStatus: "开票状态",
		colOperation: "操作",
		actInvoice: "开票",
		statusCreated: "待支付",
		statusPayed: "已支付",
		statusUsed: "已使用",
		invoiceNotIssued: "未开票",
		invoiceIssued: "已开票",
		dialogTitle: "填写开票信息",
		titleSection: "抬头信息",
		fieldAmount: "发票金额",
		amountUnit: "元",
		fieldHeaderType: "抬头类型",
		typePersonal: "个人/非企业单位",
		typeEnterprise: "企业",
		fieldInvoiceType: "发票类型",
		invoiceTypeValue: "增值税普通电子发票",
		fieldHeader: "发票抬头",
		placeholderInput: "请输入",
		placeholderHeader: "请输入发票抬头",
		fieldTaxNumber: "纳税人识别号",
		placeholderTaxNumber: "请输入15-20位的纳税人识别号",
	},
	subProjectManage: {
		title: "子项目列表",
		breadCrumb: "项目管理 / {parent}",
		newSubProject: "新建子项目",
		searchPlaceholder: "请输入子项目名称",
	},
	projectList: {
		projectCode: "项目编码",
		centerCount: "中心数量",
		patientCount: "入组患者数量",
		subProjects: "子项目列表",
		openProject: "进入项目",
		emptyHint: "您还没有任何项目，快去创建一个项目吧～",
		createProject: "创建项目",
		noticeSystem: "系统通知",
		noticeOcr: "OCR识别",
		noticeChallenge: "数据质疑",
	},
	projectHead: {
		projectName: "项目名称",
		rootProjectName: "根项目名称",
		subProjectName: "子项目名称",
		parentProject: "关联队列项目",
		specialty: "关联专科",
		disease: "关联疾病",
		formConfig: "表单配置",
		followUpConfig: "随访配置",
		schemaSnapshot: "架构快照",
	},
	home: {
		leadCentre: "牵头单位",
		maskedHospital: "****医院",
		projectLead: "项目负责人",
		projectTerm: "项目期限",
		pendingReply: "待回复问诊",
		clickToReply: "点击查看并回复 →",
		totalCases: "病例总数",
		newCasesThisMonth: "本月新增病例",
		avgCompleteness: "平均完整度",
		followUpOverdue: "随访超窗",
		view: "查看",
		notifications: "项目通知",
		index: "序号",
		notificationType: "通知类型",
		notificationContent: "通知内容",
		count: "人数",
		enrollmentTrend: "入组情况",
		genderRatio: "男女比例",
		ageDistribution: "年龄分布",
	},
};
